import { render } from "./UsuarioEmpr.vue?vue&type=template&id=de67086e"
import script from "./UsuarioEmpr.vue?vue&type=script&lang=js"
export * from "./UsuarioEmpr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__